interface SidebarChartStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const SidebarChartStatic = ({
  width = 24,
  height = 24,
  className,
  color = 'currentColor',
  strokeWidth = 2
}: SidebarChartStaticProps) => {
  // Original paths from SidebarChart.tsx (normal state)
  const topBlock =
    'M1 3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3Z';
  const middleBlock =
    'M6 10a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-5Z';
  const bottomBlock =
    'M1 17a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-5Z';

  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Top block */}
        <path
          d={topBlock}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="butt"
          strokeLinejoin="miter"
        />

        {/* Middle block */}
        <path
          d={middleBlock}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="butt"
          strokeLinejoin="miter"
        />

        {/* Bottom block */}
        <path
          d={bottomBlock}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="butt"
          strokeLinejoin="miter"
        />
      </svg>
    </div>
  );
}; 